import { useGlobal } from '~/components/Common/GlobalDataProvider'
import { Toast } from '~/components/Common/Toast'
import { delayedCallback } from '~/utils'

export const ToastWrapper = () => {
    const { toastProps, setToastProps } = useGlobal()

    const handleClose = () => {
        setToastProps({
            ...toastProps,
            open: false
        })

        if (toastProps.onClose) {
            toastProps.onClose()
        }

        delayedCallback(() => {
            setToastProps({
                message: ''
            })
        }, 500)
    }

    return <Toast {...toastProps} onClose={handleClose}></Toast>
}
